import { render, staticRenderFns } from "./InputCustom.vue?vue&type=template&id=570d403a"
import script from "./InputCustom.vue?vue&type=script&lang=js"
export * from "./InputCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports